const config = {
  dev: {
    // api: "http://192.168.3.95:8080/app",
    api: "http://192.168.3.75:8080/",
    // api: "https://app-backend.ipfsa.io/app_backend",
    // api:"https://backend.rc.ipfsa.info/app_backend/",
    // api: "https://backend.rc.ipfsa.org/app_backend",
    // api: "https://dev.repeatlink.cn/app_backend",
    ossUrl: 'https://gangwanyuan.oss-cn-beijing.aliyuncs.com/'
  },
  test: {
    // api: "https://dev.repeatlink.cn/app_backend",
    api: "https://backend.rc.ipfsa.org/app_backend/",
    // api: "https://backend.rc.xingjigangwan.com/app_backend",
    ossUrl: 'https://gangwanyuan.oss-cn-beijing.aliyuncs.com/'
  },
  pre: {
    api: "https://backend.rc.ipfsa.info/app_backend/",
    ossUrl: 'https://gangwanyuan.oss-cn-beijing.aliyuncs.com/'
  },
  pro: {
      api: "https://app-backend.ipfsa.io/app_backend",
      ossUrl: 'https://gangwanyuan.oss-cn-beijing.aliyuncs.com/'
  }
};

export default {
    ENV: process.env.VUE_APP_DOMAIN_CONFIG,
    ...config[process.env.VUE_APP_DOMAIN_CONFIG]
};